import React from 'react';
import SearchBar from '../../../../Components/Organisms/SearchBar';
import { useData } from './data';
import {
    arrowSvg,
    bigRewardCoinSvg,
    coinSvg,
    giftSvg,
    moneyBagSvg,
    verifiedSvg
} from './svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { authActions } from '../../../../store/auth-slice';
import { toIndianRs, toNumberFormat } from '../../../../helpers';
import TiTick from '@meronex/icons/ti/TiTick';
import { getConfig } from '../../../../utils/config';
import BundleOffers from '../BundleOffers';
import BsInfoCircle from '@meronex/icons/bs/BsInfoCircle';
import { useState } from 'react';
import Modal from '../../../../Components/Organisms/Modal';
import ReactPlayer from 'react-player';
import VideoModal from '../../../../Components/Organisms/VideoModal';

function Header({
    searchValue,
    onSearchChange,
    internalWebview,
    isRewards,
    userAccountSummary,
    claimNowHandler,
    kycStatus,
    isBundeOffers
}) {
    const config = getConfig();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const { cashback } = useData();
    const history = useHistory();
    const dispatch = useDispatch();
    const kycNotCompleted =
        kycStatus == 'NOT_INITIATED' ||
        kycStatus == 'INITIATED' ||
        kycStatus == 'null' ||
        kycStatus == 'FAILED' ||
        kycStatus == 'PROCESSING';
    const kycCompleted = kycStatus == 'COMPLETED';
    // const internalWebview = useSelector(
    //     (state) => state.webView.internalWebview
    // );
    const isSpecialConfig = config.id === 19 || config.id === 14;
    const backgroundClass = isSpecialConfig ? 'bg-[#EDEEF0]' : 'bg-primary';
    const textColorClass = isSpecialConfig ? 'text-black' : 'text-white';
    const buttonBg = isSpecialConfig ? 'bg-[#46434333]' : 'bg-[#FFFFFF33]';
    const [playKYCVideo, setPlayKYCVideo] = useState(false);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // console.log(
    //     'kyc completed',
    //     kycCompleted,
    //     'kycNotCompleted',
    //     kycNotCompleted
    // );
    const handleRewardClick = () => {
        if (isAuthenticated) {
            history.push('/myprofile/rewards');
        } else {
            history.push(`/deals?postLoginUrl=myprofile/rewards`);
            dispatch(authActions.openLoginModal());
        }
    };

    const totalPoints = Number(
        userAccountSummary?.unInvoicedCommission +
            userAccountSummary?.rewardPoints
    );
    // console.log('totalPoints', totalPoints > 0);

    const claimCTA = () => {
        if (totalPoints <= 0) {
            window?.webengage?.track('ReferralSection', { From: 'Rewards' });

            if (internalWebview && isIOS) {
                var valueToSend = {
                    type: 'OPEN_REFERRAL_IN_BROWSER',                                  
                };
                window?.webkit?.messageHandlers?.jsMessageHandler.postMessage(
                    valueToSend
                );
            } else {
                history.push('/gift-and-earn');
            }
            return;
        }

        claimNowHandler(false, true, false);
    };
    const handleRedeemClick = () => {
        history.push('/rewardStore', { scrollTo: 'rewards' });
    };

    return (
        <div className="flex flex-col lg:flex-row text-white gap-x-5 cursor-pointer">
            <div
                className={` ${
                    isBundeOffers
                        ? 'w-full '
                        : 'w-full lg:w-[80%] xl:w-[75%] 2xl:w-[80%]'
                } ${
                    internalWebview ? 'sticky top-0 z-10 bg-white py-1 ' : ''
                } `}
            >
                {!isRewards && (
                    <div
                        className={`${
                            internalWebview
                                ? 'fixed top-0 z-10 w-[95%]  lg:w-[70%] pt-4 pb-1 bg-white'
                                : ''
                        }`}
                    >
                        <SearchBar
                            searchValue={searchValue}
                            onSearchChange={onSearchChange}
                            // navigateOnClick
                        />
                    </div>
                )}

                {
                    <div
                        className={`hidden lg:block w-full h-full ${
                            internalWebview ? 'mt-16' : ''
                        } ${isRewards ? '' : 'mt-4'}`}
                    >
                        {!isBundeOffers && (
                            <img
                                className="w-full h-full md:h-auto object-cover rounded-xl cursor-default"
                                src={
                                    isRewards
                                        ? config?.deals?.rewardsBanner
                                              ?.backgroundImage
                                            ? config?.deals?.rewardsBanner
                                                  ?.backgroundImage
                                            : 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1727098888354_reward banner web'
                                        :  'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1717359717328_deal new main banner'
                                }
                            />
                        )}
                        {isBundeOffers &&
                            config?.clientId ==
                                '4757d92ecbc85bd93320870e1d15ae79788920c0cbf41abe884bfbc4980a0c08' && (
                                <img
                                    className="w-full h-full md:h-auto object-cover rounded-xl"
                                    src={
                                        'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1729488243491_godrej-welcomegift-banner'
                                    }
                                />
                            )}
                    </div>
                }

                {isRewards && (
                    <div className={`lg:hidden w-full h-full`}>
                        <img
                            className="w-full h-full md:w-auto md:h-auto object-cover rounded-xl"
                            src={
                                config?.deals?.rewardsBanner
                                    ?.backgroundImageMobile
                                    ? config?.deals?.rewardsBanner
                                          ?.backgroundImageMobile
                                    : 'https://loyalie-cms-dev.s3.ap-south-1.amazonaws.com/1727430271982_rewardStoreMob'
                            }
                        />
                    </div>
                )}
            </div>
            {!isBundeOffers && (
                <div
                    className={`flex flex-col w-full lg:w-[30%] xl:w-[25%] 2xl:w-[24%] px-5 py-10 lg:py-5 xl:py-10 rounded-xl ${
                        internalWebview ? 'mt-14' : 'mt-4 lg:mt-0'
                    } ${
                        isRewards
                            ? `justify-between ${backgroundClass}`
                            : 'bg-primary'
                    }`}
                >
                    {isRewards && (
                        <>
                            {/* <div
                                onClick={() =>
                                    !isAuthenticated
                                        ? dispatch(authActions.openLoginModal())
                                        : null
                                }
                                className="flex flex-col"
                            >
                                <div className="flex flex-row lg:flex-col items-start justify-between w-full lg:w-auto">
                                    {giftSvg}
                                    {kycCompleted && (
                                        <div className="inline-flex items-center lg:mt-6 py-1 px-3 rounded bg-[#FFFFFF33] text-white">
                                            {verifiedSvg}
                                            <p className="ml-2">KYC verified</p>
                                        </div>
                                    )}
                                </div>
                                <div
                                    className={`flex lg:flex-col items-center lg:items-start justify-between w-full lg:w-auto mt-6 ${
                                        kycCompleted ? 'lg:mt-0' : 'lg:mt-4'
                                    } `}
                                >
                                    <div className="">
                                        <p className="xl:mt-6 lg:text-sm xl:text-base">
                                            {isAuthenticated
                                                ? totalPoints <= 0
                                                    ? "You don't have Rewards to claim"
                                                    : 'You have rewards waiting for you'
                                                : 'Login to check Rewards eligibility'}
                                        </p>
                                        <div className="flex items-center mt-2">
                                            {bigRewardCoinSvg}
                                            <h1 className="text-2xl font-semibold ml-2">
                                                {totalPoints}
                                            </h1>
                                        </div>
                                    </div>
                                    {!isAuthenticated && (
                                        <button
                                            onClick={() =>
                                                dispatch(
                                                    authActions.openLoginModal()
                                                )
                                            }
                                            className="lg:mt-3 py-1 px-7 rounded bg-[#FFFFFF33] text-white"
                                        >
                                            Login
                                        </button>
                                    )}
                                    {kycNotCompleted && isAuthenticated && (
                                        <button
                                            onClick={claimCTA}
                                            className="lg:mt-3 xl:mt-6 py-1 px-3 rounded bg-[#FFFFFF33] text-white"
                                        >
                                            {totalPoints <= 0
                                                ? 'Refer Now'
                                                : kycNotCompleted
                                                ? 'Complete KYC'
                                                : 'Claim your points'}
                                        </button>
                                    )}
                                </div>
                            </div> */}

                            <div
                                onClick={() =>
                                    !isAuthenticated
                                        ? dispatch(authActions.openLoginModal())
                                        : null
                                }
                                className="flex flex-col"
                            >
                                <div className=" mt-2">
                                    {kycCompleted && isAuthenticated && (
                                        <div className={`${textColorClass}`}>
                                            <p className="ml-2">
                                                ✅ KYC Completed
                                                {totalPoints > 0
                                                    ? ' – You’re ready to redeem your rewards!'
                                                    : ''}
                                            </p>
                                        </div>
                                    )}

                                    {!kycCompleted &&
                                        isAuthenticated &&
                                        totalPoints > 0 && (
                                            <div
                                                className={`${textColorClass}`}
                                            >
                                                <p className="ml-2">
                                                    {kycStatus ===
                                                    'PROCESSING' ? (
                                                        <>
                                                            ⏳ KYC under
                                                            process.
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="flex justify-end -mt-3 xl:-mt-5 mb-3 mr-2">
                                                                <BsInfoCircle
                                                                    onClick={() =>
                                                                        setPlayKYCVideo(
                                                                            true
                                                                        )
                                                                    }
                                                                    className="cursor-pointer w-4 h-4 text-white font-bold"
                                                                />
                                                            </div>
                                                            <span>
                                                                🚫 KYC Pending –
                                                                Complete your
                                                                verification to
                                                                redeem your
                                                                rewards.​
                                                            </span>
                                                            {/* 🚫 KYC Pending –
                                                            Complete your KYC to
                                                            redeem your rewards. */}
                                                        </>
                                                    )}
                                                </p>
                                            </div>
                                        )}
                                </div>

                                <div
                                    className={`flex flex-col  items-start w-full mt-6 `}
                                >
                                    <div className="flex  items-center gap-1">
                                        <div>{giftSvg}</div>
                                        <div className="">
                                            <p
                                                className={`lg:text-sm xl:text-base ml-2 ${textColorClass}`}
                                            >
                                                {isAuthenticated
                                                    ? totalPoints <= 0
                                                        ? userAccountSummary?.claimedRewardPoints >
                                                          0
                                                            ? 'You have claimed your rewards. Refer now to earn more rewards!'
                                                            : "You don't have Rewards to claim"
                                                        : 'You have rewards waiting for you'
                                                    : 'Login to check Rewards eligibility'}
                                            </p>
                                        </div>
                                    </div>

                                    {/* {isAuthenticated && kycCompleted && (
                                        <button
                                            onClick={handleRedeemClick}
                                            className={`mt-4 lg:mt-5 xl:mt-8 py-2 px-8 rounded ${buttonBg} ${textColorClass} font-bold ml-1`}
                                        >
                                            Redeem Now
                                        </button>
                                    )} */}

                                    {!isAuthenticated && (
                                        <button
                                            onClick={() =>
                                                dispatch(
                                                    authActions.openLoginModal()
                                                )
                                            }
                                            className={`mt-4 lg:mt-5 xl:mt-8  py-2  px-10 rounded  ${buttonBg} ${textColorClass} font-bold ml-1`}
                                        >
                                            Login
                                        </button>
                                    )}
                                    {/* {kycNotCompleted && isAuthenticated && (
                                        <button
                                            onClick={claimCTA}

                                            className={`mt-4 lg:mt-5 xl:mt-8 py-2 px-8 rounded ${buttonBg} ${textColorClass} font-bold ml-1`}
                                        >
                                            {totalPoints <= 0
                                                ? 'Refer Now'
                                                : kycNotCompleted
                                                ? 'Complete KYC'
                                                : ''}
                                        </button>
                                    )} */}

                                    {isAuthenticated && (
                                        <button
                                            onClick={
                                                totalPoints > 0 && kycCompleted
                                                    ? handleRedeemClick
                                                    : claimCTA
                                            }
                                            className={`mt-4 lg:mt-5 xl:mt-8 py-2 px-8 rounded ${buttonBg} ${textColorClass} font-bold ml-1`}
                                        >
                                            {totalPoints > 0 && kycCompleted
                                                ? 'Redeem Now'
                                                : totalPoints <= 0
                                                ? 'Refer Now'
                                                : 'COMPLETE KYC​'}
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* <button
                                className=" flex items-center gap-1 text-white cursor-pointer mt-6 lg:mt-7 xl:mt-0"
                                onClick={() => {
                                    window?.webengage?.track(
                                        'ContactUsClicked',
                                        {
                                            Section: 'Rewards Store'
                                        }
                                    );
                                    history.push(
                                        '/contact-us?referralissue=true'
                                    );
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                >
                                    <g
                                        id="_4213468_help_lifesaver_support_icon"
                                        data-name="4213468_help_lifesaver_support_icon"
                                        transform="translate(-1.2 -1.2)"
                                    >
                                        <path
                                            id="Path_7102"
                                            data-name="Path 7102"
                                            d="M11.2,1.2a10,10,0,1,0,10,10A10,10,0,0,0,11.2,1.2Zm0,1.21A8.683,8.683,0,0,1,16.869,4.5l-2.42,2.4a5.351,5.351,0,0,0-6.5,0L5.531,4.5A8.768,8.768,0,0,1,11.2,2.41Zm4.172,8.79A4.172,4.172,0,1,1,11.2,7.028,4.176,4.176,0,0,1,15.372,11.2ZM2.41,11.2A8.668,8.668,0,0,1,4.655,5.356l2.4,2.4a5.368,5.368,0,0,0-.143,6.688L4.5,16.869A8.768,8.768,0,0,1,2.41,11.2Zm8.79,8.79a8.668,8.668,0,0,1-5.844-2.245l2.4-2.4a5.383,5.383,0,0,0,6.879,0l2.4,2.4A8.746,8.746,0,0,1,11.2,19.99Zm6.7-3.121-2.4-2.42A5.4,5.4,0,0,0,16.6,11.2a5.321,5.321,0,0,0-1.242-3.439l2.4-2.4A8.776,8.776,0,0,1,20.006,11.2,8.868,8.868,0,0,1,17.9,16.869Z"
                                            transform="translate(0 0)"
                                            fill={'#ffffff'}
                                        />
                                    </g>
                                </svg>
                                <p className="underline text-sm lg:text-xs xl:text-sm font-semibold text-left">
                                    Data not reflecting correctly?
                                </p>
                            </button> */}
                        </>
                    )}
                    {!isRewards && (
                        <div onClick={handleRewardClick}>
                            {cashback ? (
                                <div className="flex flex-row md:flex-col justify-start md:justify-center items-center lg:items-start pb-5">
                                    {coinSvg}
                                    <div className="ml-4 md:ml-0">
                                        <h1 className="text-2xl font-semibold mt-0 lg:mt-6">
                                            {toIndianRs(cashback)}
                                        </h1>
                                        <h3 className="text-lg font-semibold mt-0 lg:mt-3">
                                            Total Cashback
                                        </h3>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex flex-row md:flex-col md:justify-center items-center pb-5">
                                    {moneyBagSvg}

                                    <div className="ml-4 md:ml-0">
                                        {config?.deals?.dealsSection
                                            ?.referralText ? (
                                            <div>
                                                {
                                                    config?.deals?.dealsSection
                                                        ?.referralText
                                                }
                                            </div>
                                        ) : (
                                            <div>
                                                <p>
                                                    Refer a friend or share our{' '}
                                                </p>
                                                <p>
                                                    deals to earn a scratch
                                                    card!
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                            <div
                                onClick={() =>
                                    history.push('/myprofile/rewards')
                                }
                                className="flex justify-between items-center cursor-pointer border-t-[2px] border-[#FFFFFF33] pt-5 gap-x-3"
                            >
                                <div>
                                    <p className="font-medium text-base md:text-sm ">
                                        Scratch and win exciting rewards!
                                    </p>
                                    <p className="mt-2 text-xs">
                                        Check your ongoing rewards and scratch
                                        to reveal your prizes.
                                    </p>
                                </div>
                                {arrowSvg}
                            </div>
                        </div>
                    )}
                </div>
            )}
            <VideoModal
                isVisible={playKYCVideo}
                setIsVisible={setPlayKYCVideo}
                videoUrl="https://www.youtube.com/shorts/yGU-AIZlxw8"
            />
        </div>
    );
}

export default Header;
